import React from "react";
import RejectButton from "@components/FlowActionButtons/RejectButton";
import { canUserReject } from "@features/vessel-call/vessel-call-status/ShippingAgencyTransfer/flow/utils";
import type { ShippingAgencyTransfer } from "@services/shipping-agency-transfer/types";

interface RejectShippingAgencyTransferProps {
  transferDetails: ShippingAgencyTransfer | null;
  openDrawer: (drawerName: string) => void;
}

const LANG_BASE = "vessel-call.shipping-agency-transfer";

const RejectShippingAgencyTransfer: React.FC<RejectShippingAgencyTransferProps> = ({
  transferDetails,
  openDrawer,
}) => {
  if (!transferDetails?.task) {
    return null;
  }

  const isActionAvailable = canUserReject(
    transferDetails.task.status,
    transferDetails.task.claimOwnerName,
    transferDetails.status,
  );

  return (
    <RejectButton
      langBase={`${LANG_BASE}.flow-buttons`}
      permission="canRejectShippingAgencyTransfer"
      isActionAvailable={isActionAvailable}
      onReject={() => openDrawer("rejectDrawer")}
    />
  );
};

export default RejectShippingAgencyTransfer;
